import { PrimitiveValueObjectDate } from '@/domain/primitiveValueObjectDate';

/**
 * 記録対象日
 */
export class RecordDate extends PrimitiveValueObjectDate {
  /**
   * 生成
   * @param value 値
   * @returns 生成値
   */
  static create(value: Date): RecordDate {
    return new RecordDate(value);
  }
}
